"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../../comps/reusables");
const graphql_1 = require("../../../../../graphql");
const react_2 = require("@osmosys/react");
const react_hanger_1 = require("react-hanger");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const inputs_1 = require("../../../../../inputs");
const Outer_1 = require("../../../../../panels/ContentImportPanel/Outer");
const portals_1 = require("../../../../../portals");
const ContentFeedPushInfo_1 = require("./ContentFeedPushInfo");
exports.ContentFeedCanvasForm = ({ contentFeed, cms, formikProps, updateResult }) => {
    const { history } = use_react_router_1.default();
    const { state, setState } = react_hanger_1.useSetState({
        showContentItemsPanel: false,
        showContentPushSaveReminder: false,
        showImportHeaders: false,
        showTestRequestPopover: false,
    });
    const onSave = () => {
        setState({
            showContentPushSaveReminder: false,
        });
        formikProps.submitForm();
    };
    const showingImport = formikProps.values.useHeadersFromContentFeed || state.showImportHeaders;
    const importHeaders = () => {
        if (formikProps.values.headers) {
            const c = confirm('Are you sure? This will unset other headers');
            if (!c) {
                return;
            }
        }
        setHeaders(null);
        setState({
            showImportHeaders: true,
        });
    };
    const setHeaders = (val) => {
        if (showingImport) {
            formikProps.setFieldValue('useHeadersFromContentFeed', null);
            formikProps.setFieldValue('headers', null);
            setState({
                showImportHeaders: false,
            });
        }
        else {
            formikProps.setFieldValue('useHeadersFromContentFeed', null);
            formikProps.setFieldValue('headers', val);
        }
    };
    const headersToolbar = (react_1.default.createElement(react_2.OsmosysDiv, { osysName: "ContentFeedCanvas.headersToolbar", className: "d-flex flex-row w-100" },
        react_1.default.createElement(react_2.OsmosysDiv, null,
            react_1.default.createElement("div", { className: "flex-grow-1 flex-shrink-0" },
                react_1.default.createElement(reactstrap_1.Label, { className: "font-weight-bold" },
                    "Request headers",
                    state.showImportHeaders
                        ? formikProps.errors.useHeadersFromContentFeed && (react_1.default.createElement("span", { className: classnames_1.default('ml-1', formikProps.errors.headers ? 'text-danger' : '') },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faExclamationCircle }),
                            ' ',
                            formikProps.errors.useHeadersFromContentFeed))
                        : formikProps.errors.headers && (react_1.default.createElement("span", { className: classnames_1.default('ml-1', formikProps.errors.headers ? 'text-danger' : '') },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faExclamationCircle }),
                            ' ',
                            formikProps.errors.headers)))),
            react_1.default.createElement("div", { className: "flex-shrink-1 flex-grow-0" },
                !showingImport && (react_1.default.createElement("span", { className: "text-muted" },
                    react_1.default.createElement("a", { href: "a", onClick: e => {
                            e.preventDefault();
                            importHeaders();
                        }, className: "text-muted" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faFileImport })),
                    ' ',
                    react_1.default.createElement("a", { href: "a", onClick: e => {
                            e.preventDefault();
                            importHeaders();
                        }, className: "text-muted" },
                        react_1.default.createElement("span", { className: "d-lg-none" }, "Link headers"),
                        react_1.default.createElement("span", { className: "d-none d-lg-inline" }, "Use headers from another content feed")))),
                react_1.default.createElement("span", { className: "ml-2 text-muted" },
                    react_1.default.createElement("a", { href: "a", onClick: e => {
                            e.preventDefault();
                            setHeaders(null);
                        }, className: "text-muted" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faEraser })),
                    ' ',
                    react_1.default.createElement("a", { href: "a", onClick: e => {
                            e.preventDefault();
                            setHeaders(null);
                        }, className: "text-muted" }, "Clear"))))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysDiv, { className: "text-center mb-1" },
            react_1.default.createElement(reactstrap_1.Badge, { color: "dark" },
                react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "contentFeed", iconStyle: "solid" }),
                " Content Feed")),
        react_1.default.createElement("h2", { className: "text-center" }, contentFeed.name),
        react_1.default.createElement(portals_1.OsmosysSidebarPortal, null,
            react_1.default.createElement(Outer_1.ContentImportPanelOuter, { isOpen: state.showContentItemsPanel, onContentImport: () => { }, onClose: () => {
                    setState({
                        showContentItemsPanel: false,
                    });
                }, contentFeed: contentFeed })),
        react_1.default.createElement(react_2.OsmosysDiv, null,
            react_1.default.createElement(react_2.OsmosysDiv, { flexCol: true },
                react_1.default.createElement(reusables_1.FormGroup, { label: "Content feed name", name: "name" }),
                react_1.default.createElement(reusables_1.FormGroup, { label: "Response type", name: "responseType", type: "select", options: [
                        { label: 'JSON', value: 'json' },
                        { label: 'XML', value: 'xml' },
                    ], selectProps: {
                        defaultValue: { label: 'JSON', value: 'json' },
                    } }),
                react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "contentMapping", cmsId: cms.id, boldLabel: true, value: formikProps.values.contentMapping, onChange: cm => {
                        formikProps.setFieldValue('contentMapping', cm);
                    } }),
                react_1.default.createElement(reusables_1.FormGroup, { label: "Cache length (seconds)", name: "cacheLength", type: "number", min: 0, max: 60 * 60 }),
                react_1.default.createElement(reactstrap_1.Collapse, { isOpen: !formikProps.values.contentPushIsEnabled },
                    react_1.default.createElement(reusables_1.FormGroup, { label: formikProps.values.contentPushIsEnabled
                            ? 'Request URL (Disabled while content push is enabled)'
                            : 'Request URL', name: "url", type: "url", disabled: formikProps.values.contentPushIsEnabled })),
                showingImport ? (react_1.default.createElement(react_1.default.Fragment, null,
                    headersToolbar,
                    react_1.default.createElement(reusables_1.FormGroup, { hideLabel: true, label: "Select content feed to share headers with", name: "useHeadersFromContentFeed", type: "querySelect", querySelectProps: {
                            isClearable: true,
                            isOptionDisabled: opt => {
                                return (`${opt.id ? opt.id : opt.value}` ===
                                    `${contentFeed.id}`);
                            },
                            pathToCount: 'contentFeedsCount',
                            pathToItems: 'contentFeeds',
                            queryProps: {
                                query: graphql_1.contentFeedsList,
                                variables: {
                                    cmsId: cms.id,
                                    take: 100,
                                },
                            },
                        } }))) : formikProps.values.headers === null &&
                    !formikProps.values.contentPushIsEnabled ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "my-4" },
                        react_1.default.createElement(reactstrap_1.Button, { color: "link", className: "p-0 mr-3", onClick: () => {
                                formikProps.setFieldValue('contentPushIsEnabled', true);
                            } }, "Switch to content push mode"),
                        react_1.default.createElement(reactstrap_1.Button, { color: "link", className: "p-0", onClick: () => {
                                formikProps.setFieldValue('headers', '{}');
                            } }, "Add request headers")),
                    state.showContentPushSaveReminder && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("p", { className: "small text-danger" },
                            react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "exclamation", iconStyle: "solid" }),
                            " To finish turning off content push mode, click \u201CSave content feed\u201D below!"))))) : formikProps.values.contentPushIsEnabled ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(ContentFeedPushInfo_1.ContentFeedPushInfo, { id: contentFeed.id, showContentItemsPanel: () => {
                            setState({
                                showContentItemsPanel: true,
                            });
                        }, contentPushUrl: contentFeed.contentPushUrl, contentPushIndividualContentItems: formikProps.values.contentPushIndividualContentItems, toggleContentPushIndividualContentItems: newVal => {
                            formikProps.setFieldValue('contentPushIndividualContentItems', newVal);
                        }, onDisable: () => {
                            if (contentFeed.contentPushIsEnabled) {
                                setState({
                                    showContentPushSaveReminder: true,
                                });
                            }
                            formikProps.setFieldValue('contentPushIsEnabled', false);
                        } }))) : (react_1.default.createElement("div", null,
                    headersToolbar,
                    react_1.default.createElement(react_2.OsmosysDiv, { osysName: "ContentFeedCanvas.CodeEditorOuter", style: { height: 300 }, className: "border" },
                        react_1.default.createElement(reusables_1.CodeEditor, { value: formikProps.values.headers, onChange: val => {
                                formikProps.setFieldValue('headers', val);
                            }, language: "json", dark: true })))),
                react_1.default.createElement("div", { className: "mt-4" },
                    react_1.default.createElement(reusables_1.MutationButton, { mutation: graphql_1.deleteContentFeed, icon: pro_solid_svg_icons_1.faTrash, type: "button", color: "warning", label: "Delete", confirm: true, className: "mr-2", variables: {
                            id: contentFeed.id,
                        }, onCompleted: () => {
                            setTimeout(() => {
                                history.push(`/integrations/${cms.id}/feeds`);
                            }, 2 * 1000);
                        } }),
                    react_1.default.createElement(reusables_1.MutationButton, { mutation: graphql_1.archiveContentFeed, icon: pro_solid_svg_icons_1.faArchive, type: "button", color: "warning", label: contentFeed.archived ? 'Unarchived' : 'Archive', variables: {
                            archived: !contentFeed.archived,
                            id: contentFeed.id,
                        }, className: "mr-2", confirm: true, onCompleted: () => {
                            setTimeout(() => {
                                history.push(`/integrations/${cms.id}/feeds`);
                            }, 2 * 1000);
                        } }),
                    react_1.default.createElement(react_2.OsmosysButton, { inline: true, osysName: "contentFeed.showContentItems", onClick: () => {
                            setState({
                                showContentItemsPanel: true,
                            });
                        }, osysIcon: "slot", color: "secondary" }, "Show content items"))),
            react_1.default.createElement(reusables_1.BottomToolbar, { right: react_1.default.createElement(react_2.OsmosysButton, { osysStyle: "save", osysName: "contentFeed.save", mutate: onSave, mutationResult: updateResult, renderApolloError: true, disabled: !formikProps.isValid }, "Save content feed") }))));
};
//# sourceMappingURL=ContentFeedCanvasForm.js.map